// AutoSaveIndicator.jsx
import { useEffect, useState } from 'react';

const AutoSaveIndicator = ({ isSaving, lastSaved }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isSaving) {
      setVisible(true);
      const timer = setTimeout(() => setVisible(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isSaving]);

  return (
    <div className={`fixed bottom-4 right-4 transition-all duration-300 ${visible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="bg-white shadow-lg rounded-lg p-4 flex items-center gap-3 border border-green-200">
        <div className={`w-3 h-3 rounded-full ${isSaving ? 'bg-yellow-400 animate-pulse' : 'bg-green-500'}`}></div>
        <span className="text-sm font-medium">
          {isSaving ? 'Saving...' : `Saved ${lastSaved}`}
        </span>
      </div>
    </div>
  );
};

export default AutoSaveIndicator;